import { Navigate } from "react-router-dom";

/**
 * Phase 1: forwards to the existing Vulnerabilities page. The mock's
 * exposure-hero + KEV cards layout is wired in phase 2.
 */
export default function MobileSecurityPage() {
  return <Navigate to="/vulnerabilities" replace />;
}
